import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { History, Clock, ArrowRight } from "lucide-react";
import api from "@/lib/api";
import { Header } from "@/pages/CollegePredictorPage";
import { TypeBadge, Crumb, err, fmtTime } from "./shared";

export default function PrepHistory() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/test-prep/attempts?limit=100").then((r) => setRows(r.data)).catch((e) => toast.error(err(e))); }, []);
  if (!rows) return <div className="p-8 text-slate-400">Loading...</div>;

  return (
    <div data-testid="prep-history" className="mx-auto max-w-6xl px-4 sm:px-8 py-8">
      <Crumb items={[{ to: "/prep", label: "Test Preparation" }, { label: "Test History" }]} />
      <Header icon={History} eyebrow="My Preparation" title="Test History" desc="Every attempt, stored against your EntranceZone AI profile. Click a test to open its full analysis." />
      {rows.length === 0 && <p data-testid="history-empty" className="text-sm text-slate-400">No tests yet. <Link to="/prep" className="text-cyan-300">Start preparing</Link>.</p>}
      <div className="overflow-hidden rounded-2xl border border-white/8">
        {rows.map((a) => {
          const r = a.result;
          const to = a.status === "submitted" ? `/prep/result/${a.id}` : `/prep/test/${a.id}`;
          return (
            <Link key={a.id} to={to} data-testid="history-row" className="grid grid-cols-[1fr_auto] items-center gap-3 border-b border-white/5 bg-[#131C2E] px-4 py-3 text-sm last:border-0 hover:bg-white/[0.03] sm:grid-cols-[1fr_120px_110px_90px_90px_24px]">
              <div className="min-w-0">
                <div className="flex flex-wrap items-center gap-2"><TypeBadge type={a.test_type} /><span className="text-xs text-slate-500">{a.exam_name}</span></div>
                <p className="mt-1 truncate font-medium">{a.title}</p>
                <p className="text-xs text-slate-500">{new Date(a.created_at).toLocaleString()}</p>
              </div>
              {a.status === "submitted" ? (
                <>
                  <p className="hidden font-mono-data font-bold text-cyan-300 sm:block">{r.score} / {r.total_marks}</p>
                  <p className="hidden text-xs text-slate-400 sm:block">{r.accuracy}% accuracy</p>
                  <p className="hidden text-xs text-slate-400 sm:block"><Clock className="inline h-3 w-3" /> {fmtTime(r.time_taken_sec)}</p>
                  <p className="hidden text-xs text-slate-400 sm:block">{r.correct}✓ {r.incorrect}✗ {r.unattempted}–</p>
                </>
              ) : (
                <p className="col-span-1 text-xs font-semibold text-amber-300 sm:col-span-4">In progress — resume</p>
              )}
              <ArrowRight className="h-4 w-4 text-slate-500" />
            </Link>
          );
        })}
      </div>
    </div>
  );
}
